/* eslint-disable no-undef */
import axios from "axios";

const addres = `${process.env.REACT_APP_DOMAIN}api`;

const api = axios.create({ baseURL: `${addres}` });

api.interceptors.request.use(function (config) {
	const token = localStorage.getItem("token");
	if (token) {
		config.headers["x-jwt"] = token;
	}

	if (!config.headers["Content-Type"]) {
		config.headers["Content-Type"] = "application/json";
	}
	return config;
});

export { api };
